import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import axios from 'axios';
import MyButton from 'components/form/MyButton';
import TopBar from 'components/layout/TopBar';
import { initAxios } from 'components/utils/FormatData';
import { ADD_NEW_MESSAGE } from 'constants/constants';
import useAuthn from 'hooks/useAuthn';
import useWebSocket from 'hooks/useWebSocket';
import _ from 'lodash';
import 'moment/locale/fr';
import React, { useEffect, useState } from 'react';
import { positions, Provider as AlertProvider, transitions } from 'react-alert';
import { isMobile } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './App.css';
import AlertTemplate from './components/AlertTemplate';
import Layout from './components/layout/Layout';
import { DEBUG_MODE, WS_URL } from './constants/settings';
import useWindowSize from './hooks/useWindowSize';
import routes from './routes';
import Home from './views/home/Home';

const options = {
  position: positions.BOTTOM_CENTER,
  timeout: 5000,
  transition: transitions.FADE,
  containerStyle: {
    zIndex: 9999,
  },
};

const App = () => {
  const [getValidToken, logout] = useAuthn();
  const [width, height] = useWindowSize();
  const [wsIsConnected, setWsIsConnected] = useState(DEBUG_MODE ? true : null);
  const auth = useSelector(state => state["authentification"]);
  const dispatch = useDispatch();


  // Gestion des push websocket
  const handleWsMessage = (msgWs) => {
    if (msgWs) {
      const type = msgWs['Type'];
      if (type.includes('sed.EQUIPEMENT')) {
        const equipment = msgWs['Payload'];
        console.log(`>> WS : ${type} : ${equipment.idSociete}`);
        dispatch({ type: ADD_NEW_MESSAGE, payload: msgWs });
      } else if (type.includes('sed.COMMANDE')) {
        const commande = msgWs['Payload'];
        console.log(`>> WS : ${type} : ${commande.id}`);
        dispatch({ type: ADD_NEW_MESSAGE, payload: msgWs });
      }
    }
  }

  // Gestion des changements de status du websocket
  const updateStatus = (status) => {
    setWsIsConnected(status);
  }

  // Retourne composant en cas d'authentification réussi à l'application
  const getAuthenticatedApp = () => {
    return (
      <MuiPickersUtilsProvider utils={MomentUtils} locale="fr">
        <AlertProvider template={AlertTemplate} {...options}>
          <BrowserRouter basename={process.env.PUBLIC_URL}>
            <Switch>
              <Route exact path="/"
                render={(route) =>
                  <Layout
                    component={Home}
                    route={route}
                    logout={logout}
                    wsStatus={wsIsConnected}
                  />
                } />
              {_.map(routes, (route, key) => {
                const { component, path, params } = route;
                return (
                  <Route
                    exact
                    path={path}
                    key={key}
                    render={(route) =>
                      <Layout
                        component={component}
                        route={route}
                        params={params}
                        logout={logout}
                        wsStatus={wsIsConnected}
                      />
                    }
                  />
                );
              })}
              <Layout
                component={() => (
                  <div id="error-404" className={!isMobile ? "panel-contenu" : "panel-contenu-mobile-tablette"} style={{ height: !isMobile ? height - 110 : height - 60 }}>
                    <TopBar title="Erreur 404" className={!isMobile ? "topbar-contenu" : "topbar-contenu-mobile-tablette"} color="#0094ca" buttons={null} />
                    <div className="row" style={{ height: !isMobile ? height - 200 : height - 150, justifyContent: 'center', alignContent: 'center' }}>
                      <p className='error-page'>La page demandée n'existe pas! Ooooops</p>
                      <MyButton className="classic-button btn-default color-fond-bleu" type="button" labelImportant="Retour à l'accueil" href="/" />
                    </div>
                  </div>
                )}
                logout={logout}
                wsStatus={wsIsConnected}
              />

            </Switch>
          </BrowserRouter>
        </AlertProvider>
      </MuiPickersUtilsProvider >
    );
  }

  // Retourne composant en cas de non authentification à l'application
  const getNoAuthApp = () => {
    return (
      <MuiPickersUtilsProvider utils={MomentUtils} locale="fr">
        <AlertProvider template={AlertTemplate} {...options}>
          <BrowserRouter basename={process.env.PUBLIC_URL}>
            <Switch>
              <Layout
                component={() => (
                  <div id="error-401" className={!isMobile ? "panel-contenu" : "panel-contenu-mobile-tablette"} style={{ height: !isMobile ? height - 110 : height - 60 }}>
                    <TopBar title="Erreur d'authentification" className={!isMobile ? "topbar-contenu" : "topbar-contenu-mobile-tablette"} color="#0094ca" buttons={null} />
                    <div className="row" style={{ height: !isMobile ? height - 200 : height - 150, justifyContent: 'center', alignContent: 'center' }}>
                      <p className='error-page'>Vous n'êtes pas autorisé à accéder à cette application...</p>
                    </div>
                  </div>
                )}
                logout={logout}
                wsStatus={wsIsConnected}
              />
            </Switch>
          </BrowserRouter>
        </AlertProvider>
      </MuiPickersUtilsProvider >
    );
  }

  // Hook d'authentification KeyCloack
  useEffect(() => {
    if (!DEBUG_MODE) {
      initAxios(getValidToken, axios);
    }
  }, [getValidToken]);

  // Gestion du refresh token
  useEffect(() => {
    const interval = setInterval(() => {
      if (!DEBUG_MODE) getValidToken();
    }, 20000);
    return () => clearInterval(interval);
  }, [getValidToken]);

  // Hook de mise en place du WebSocket
  if (!DEBUG_MODE) {
    console.log(`[SYS] Mode DEBUG inactif`);
    useWebSocket(WS_URL, message => { handleWsMessage(message); }, status => { updateStatus(status); });
  } else {
    console.log(`[SYS] Mode DEBUG actif`);
  }

  if (wsIsConnected !== null) {
    if (auth.authenticated) {
      return getAuthenticatedApp();
    }
    if (!auth.authenticated) {
      //return getNoAuthApp();
    }
  }

  return <div />;
};

export default App;
